import React, { Component } from 'react';
import PropTypes from 'prop-types'; // ES6
import { Select } from 'antd';

const Option = Select.Option;

const renderOpcionsLlista = (opcions) => {
    return opcions.map((opcio, index) => {
        return (
            <Option
                key={opcio.id + '-' + index}
                value={opcio.id}>
                {opcio.valor}
            </Option>
        );
    });
};

class VariableLlista extends Component {

    render() {
        const { estils, variable, allowClear } = this.props;
        const missatgeLlistaBuida = 'No s\'han trobat opcions';
        const valorsSeleccionats = variable.valor;
        const valorsPossibles = variable.valorsPossibles || [];
        const mode = variable.multiple ? 'multiple' : null;

        const idDiv = 'selector-scrollable' + (variable.id ? variable.id : '');
        const estilsDiv = estils && estils.contenidor ? estils.contenidor : '';
        const estilsSelector = estils && estils.selector ? estils.selector : '';

        return (
            <div id={idDiv} className={estilsDiv}>
                {variable.nom}
                <Select
                    className={estilsSelector}
                    mode={mode}
                    notFoundContent={missatgeLlistaBuida}
                    value={valorsSeleccionats}
                    getPopupContainer={() => document.getElementById(idDiv)}
                    onChange={this.props.onChangeValorVariable}
                    allowClear={allowClear} >
                    {renderOpcionsLlista(valorsPossibles)}
                </Select>
            </div>
        );
    }
}

VariableLlista.propTypes = {
    estils: PropTypes.object,
    variable: PropTypes.object,
    allowClear: PropTypes.bool,
    onChangeValorVariable: PropTypes.func
};

export default VariableLlista;



// WEBPACK FOOTER //
// ./src/components/commons/variableLlista.js